/* eslint semi:0 */
const SELECTORS = {
  NAVBAR_SOCIAL_COMPONENT: '.header-post-actions',
  SHARE_COVER_COMPONENT: '.share-component--post-cover',
  FOOTER_SOCIAL_ICONS: '.share-component--post-body',
  BOTTOM_SOCIAL_ICONS: '.bottom-social',
  SEARCH_COMPONENT: '.search-comp',
  JWPLAYER_BODY: '.Jwplayer-container',
  USER_MENU_DROPDOWN: '.user-menu.has-dropdown',
  POST_METADATA_STATS: '.post-metadata__stats',
  COMMUNITY_DISCLAIMER: '.community-disclaimer',
  FACEBOOK_COMMENTS: '.facebook-comments',
  ADMIN_DROPDOWN: '.post-admin-options',
  SITE_HEADER: '#site-header',
  SLIDE: '.slide',
  SLIDE_CONTAINER: '.slideshow__slide',
  POST_BODY_SELECTOR: '.post-body',
  POST_BODY_WRAP_SELECTOR: '.post-body-wrap',
  POST_CONTENT_SELECTOR: '.post-content',
  SOCIAL_BAR__COVER: '.social-bar--cover',
  SOCIAL_BAR__HEADER: '.social-bar--header',
  SOCIAL_BAR__DETAILS: '.social-bar--details',
  SOCIAL_BAR__BOTTOM: '.social-bar--bottom',
  SLIDESHOW_POST_METADATA: '.post-metadata',
  PLAYBYZZ_CONTAINER: '.pb_feed',
  SCRIBBLELIVE_CONTAINER: '.scrbbl-embed[data-src]',
  FANORAKEL: '.fanorakel',
  POST_COVER: '.post-cover',
  MAIN_SIDENAV: '.main-sidenav',
  MAIN_SIDENAV_TOGGLE: '.main-sidenav-toggle',
  MAIN_SIDENAV_CHECKBOX: '#main-sidenav-checkbox',
  EDITION_DROPDOWN: '.edition-component__dropdown',
  EDITION_COMPONENT: '.edition-component',
  PAGE_WRAP: '.page-wrap',
  HEADER_AD_UNIT: '.ad[data-slot-id="Top"]',
  MODAL: '#root-dialog',
  MODAL__MOUNT_POINT: '.modal__mount-point',
  MODAL__CLOSE_BUTTON: '.modal__close',
  POST_AFTER: '.post-after',
  TOP_POSTS_AFTER_POST: '.top-posts-after-post',
  SECTION_TITLE_TOP_POSTS_AFTER_POST: '.section-title--top-posts-after-post',
  TOP_POSTS_SIDE_BAR: '.top-posts-side-bar',
  SECTION_TITLE_TOP_POSTS_SIDE_BAR: '.section-title--top-posts-side-bar',
  TOP_POSTS_AFTER_POST_ITEM_IMAGE_CONTAINER: '.top-posts-after-post__item__image-container',
  TOP_POSTS_SIDE_BAR_ITEM_IMAGE_CONTAINER: '.top-posts-side-bar__item__image-container',
  NEWSCORP_EMBED_CONTAINER: '.newscorp-container',
  AD: '.ad',
  TABOOLA_WIDGET_CONTAINER: '.nm-taboola-widget',
  POST_ARTICLE_TITLE: '.post-article__post-title',
  PN_SUBSCRIBE_CONTAINER: '.pn-subscribe',
  PN_SUBSCRIBE_THIN: '.expandable-content__button-wrapper--pn-subscribe',
  COOKIE_DISCLAIMER: '.cookie-disclaimer',
  SCHEDULE: '.schedule-component',
  SCHEDULE_IN_FIXTURES_PAGE: '.schedule-component--scores',
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE: '.league-selection-scores',
  FANVOICE_CONTAINER: '.fanvoice',
  YAHOO_FANTASY: '.fantasy-mount-point',
  FACEBOOK_BOT: '.facebook-bot-mount-point',
  FRESH8_MOUNT_POINT: '.fresh8-mount',
  FRESH8_FLOATING: '.fresh8-floating-container',
  SCORES_TABLE: '.scores-table',
  WRITERS_ARTICLE_BUTTON: '.writers__write-article-button'
}


const SCROLL_EVENTS_BASE_SELECTOR = '.scroll-anchor'
function prefixScrollAnchorSelector(strings, ...values){
  return `${ SCROLL_EVENTS_BASE_SELECTOR }${ strings[0] }`;
}
const SCROLL_EVENTS_SELECTORS = {
  TITLE: prefixScrollAnchorSelector `.title`,
  BODY_START: prefixScrollAnchorSelector `.body-start`,
  SHARE_BUTTONS_BOTTOM: prefixScrollAnchorSelector `.share-buttons-bottom`,
  TOP_POSTS: prefixScrollAnchorSelector `.top-posts`,
  PUNDIT_MATCH: prefixScrollAnchorSelector `.pundit-match`,
  PUNDIT_TEXT: prefixScrollAnchorSelector `.pundit-text`,
  PUNDIT_TOP_PREDICTORS: prefixScrollAnchorSelector `.pundit-top-predictors`,
  PUNDIT_VBET: prefixScrollAnchorSelector `.pundit-vbet-anchor`,
  PUNDIT_PREDICT: prefixScrollAnchorSelector `.pundit-predict`,
  PN_SUBSCRIBE: prefixScrollAnchorSelector `.pn-subscribe-anchor`,
  OUTBRAIN: prefixScrollAnchorSelector `.outbrain`,
  TABOOLA: prefixScrollAnchorSelector `.taboola`,
  PAGE_END: prefixScrollAnchorSelector `.page-end`,
  // mobile only
  PUNDIT_PREDICTORS_BET: prefixScrollAnchorSelector `.pundit-predictors-bet`,
}


const MOUNT_POINTS = {
  NAVBAR_SOCIAL_COMPONENT: SELECTORS.NAVBAR_SOCIAL_COMPONENT,
  SHARE_COVER_COMPONENT: SELECTORS.SHARE_COVER_COMPONENT,
  FOOTER_SOCIAL_ICONS: SELECTORS.FOOTER_SOCIAL_ICONS,
  BOTTOM_SOCIAL_ICONS: SELECTORS.BOTTOM_SOCIAL_ICONS,
  SEARCH_COMPONENT: SELECTORS.SEARCH_COMPONENT,
  BRIGHTCOVE_COVER_PLAYER: SELECTORS.BRIGHTCOVE_COVER_PLAYER,
  BRIGHTCOVE_BODY_PLAYER: SELECTORS.BRIGHTCOVE_BODY_PLAYER,
  BRIGHTCOVE_SIDEBAR_PLAYER: SELECTORS.BRIGHTCOVE_SIDEBAR_PLAYER,
  JWPLAYER_BODY: SELECTORS.JWPLAYER_BODY,
  USER_MENU_DROPDOWN: SELECTORS.USER_MENU_DROPDOWN,
  POST_METADATA_STATS: SELECTORS.POST_METADATA_STATS,
  COMMUNITY_DISCLAIMER: SELECTORS.COMMUNITY_DISCLAIMER,
  FACEBOOK_COMMENTS: SELECTORS.FACEBOOK_COMMENTS,
  ADMIN_DROPDOWN: SELECTORS.ADMIN_DROPDOWN,
  FANORAKEL: SELECTORS.FANORAKEL,
  SLIDE: SELECTORS.SLIDE,
  SLIDE_CONTAINER: SELECTORS.SLIDE_CONTAINER,
  MODAL__MOUNT_POINT: SELECTORS.MODAL__MOUNT_POINT,
  PUNDIT_MATCH_TIME: '.pundit-match-intro__time',
  PUNDIT_TOP_PREDICTORS_EXTERNAL_PROVIDER: '.pundit-betting-wrapper',
  PUNDIT_VBET: '.pundit-vbet',
  PUNDIT_TOP_PREDICTORS: '.pundit-top-predictors',
  PN_SUBSCRIBE_CONTAINER: SELECTORS.PN_SUBSCRIBE_CONTAINER,
  COOKIE_DISCLAIMER: SELECTORS.COOKIE_DISCLAIMER,
  SCHEDULE_COMPONENT: SELECTORS.SCHEDULE,
  SCHEDULE_COMPONENT_IN_FIXTURES_PAGE: SELECTORS.SCHEDULE_IN_FIXTURES_PAGE,
  SOCIAL_BAR_COMPONENT__COVER: SELECTORS.SOCIAL_BAR__COVER,
  SOCIAL_BAR_COMPONENT__HEADER: SELECTORS.SOCIAL_BAR__HEADER,
  SOCIAL_BAR_COMPONENT__DETAILS: SELECTORS.SOCIAL_BAR__DETAILS,
  SOCIAL_BAR_COMPONENT__BOTTOM: SELECTORS.SOCIAL_BAR__BOTTOM,
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE: SELECTORS.LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE,
  PN_SUBSCRIBE_THIN: SELECTORS.PN_SUBSCRIBE_THIN,
  FANVOICE_CONTAINER: SELECTORS.FANVOICE_CONTAINER,
  FRESH8_MOUNT_POINT: SELECTORS.FRESH8_MOUNT_POINT,
  YAHOO_FANTASY_MOUNT_POINT: SELECTORS.YAHOO_FANTASY,
  FACEBOOK_BOT_MOUNT_POINT: SELECTORS.FACEBOOK_BOT,
  FRESH8_FLOATING_MOUNT_POINT: SELECTORS.FRESH8_FLOATING,
  SCORES_TABLE: SELECTORS.SCORES_TABLE,
}

export default { MOUNT_POINTS, SELECTORS, SCROLL_EVENTS_SELECTORS, }


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/config/preRenderedSelectorsConfig.js